module.exports = __webpack_public_path__ + "static/media/done.9dac8dbc.svg";